
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 6.5.0
 * Query Engine version: 173f8d54f8d52e692c7e27e72a88314ec7aeff60
 */
Prisma.prismaVersion = {
  client: "6.5.0",
  engine: "173f8d54f8d52e692c7e27e72a88314ec7aeff60"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.AdminScalarFieldEnum = {
  id: 'id',
  username: 'username',
  passwordHash: 'passwordHash',
  name: 'name'
};

exports.Prisma.AdminSessionScalarFieldEnum = {
  id: 'id',
  adminId: 'adminId',
  createdAt: 'createdAt'
};

exports.Prisma.SubscriptionPlanScalarFieldEnum = {
  id: 'id',
  name: 'name',
  price: 'price',
  minPrice: 'minPrice',
  maxPrice: 'maxPrice',
  active: 'active',
  allIn: 'allIn',
  planOrder: 'planOrder'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  hashedVkId: 'hashedVkId',
  encryptedPersonalData: 'encryptedPersonalData',
  hmac: 'hmac',
  subscriptionStatus: 'subscriptionStatus',
  planId: 'planId',
  subscriptionExpiresAt: 'subscriptionExpiresAt',
  preferences: 'preferences'
};

exports.Prisma.UserAccessScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  branchId: 'branchId',
  accessLevel: 'accessLevel',
  expiresAt: 'expiresAt'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  createdAt: 'createdAt',
  expiresAt: 'expiresAt',
  encryptedVKData: 'encryptedVKData',
  hmac: 'hmac'
};

exports.Prisma.ProblemScalarFieldEnum = {
  id: 'id',
  statement: 'statement',
  solution: 'solution',
  answer: 'answer',
  preview: 'preview',
  topicId: 'topicId',
  problemOrder: 'problemOrder',
  difficulty: 'difficulty',
  status: 'status',
  meta: 'meta',
  publishedAt: 'publishedAt',
  rating: 'rating',
  updatedAt: 'updatedAt'
};

exports.Prisma.FigureScalarFieldEnum = {
  id: 'id',
  url: 'url',
  alt: 'alt',
  width: 'width',
  height: 'height',
  placement: 'placement',
  problemId: 'problemId'
};

exports.Prisma.NoteScalarFieldEnum = {
  id: 'id',
  content: 'content',
  label: 'label',
  description: 'description',
  branchId: 'branchId'
};

exports.Prisma.TagScalarFieldEnum = {
  id: 'id',
  name: 'name'
};

exports.Prisma.TopicScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  name: 'name',
  branchId: 'branchId',
  imageSrc: 'imageSrc',
  displayOrder: 'displayOrder',
  theory: 'theory',
  meta: 'meta',
  fillStatus: 'fillStatus',
  updatedAt: 'updatedAt'
};

exports.Prisma.BranchScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  name: 'name',
  cases: 'cases',
  imageSrc: 'imageSrc',
  displayOrder: 'displayOrder',
  theory: 'theory',
  meta: 'meta',
  genitive: 'genitive',
  price: 'price',
  fillStatus: 'fillStatus',
  updatedAt: 'updatedAt'
};

exports.Prisma.ContentBlockScalarFieldEnum = {
  id: 'id',
  name: 'name',
  content: 'content',
  published: 'published',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PageScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  title: 'title',
  content: 'content',
  published: 'published',
  updatedAt: 'updatedAt'
};

exports.Prisma.MetadataScalarFieldEnum = {
  id: 'id',
  pageSlug: 'pageSlug',
  title: 'title',
  description: 'description',
  openGraph: 'openGraph'
};

exports.Prisma.EventLogScalarFieldEnum = {
  id: 'id',
  eventType: 'eventType',
  description: 'description',
  userId: 'userId',
  createdAt: 'createdAt'
};

exports.Prisma.PaymentScalarFieldEnum = {
  id: 'id',
  yookassaPaymentId: 'yookassaPaymentId',
  yookassaRefundId: 'yookassaRefundId',
  userId: 'userId',
  amount: 'amount',
  currency: 'currency',
  status: 'status',
  takenAction: 'takenAction',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.AdminOrderByRelevanceFieldEnum = {
  id: 'id',
  username: 'username',
  passwordHash: 'passwordHash',
  name: 'name'
};

exports.Prisma.AdminSessionOrderByRelevanceFieldEnum = {
  adminId: 'adminId'
};

exports.Prisma.SubscriptionPlanOrderByRelevanceFieldEnum = {
  name: 'name'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.UserOrderByRelevanceFieldEnum = {
  id: 'id',
  hashedVkId: 'hashedVkId',
  encryptedPersonalData: 'encryptedPersonalData',
  hmac: 'hmac'
};

exports.Prisma.UserAccessOrderByRelevanceFieldEnum = {
  userId: 'userId'
};

exports.Prisma.SessionOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  encryptedVKData: 'encryptedVKData',
  hmac: 'hmac'
};

exports.Prisma.ProblemOrderByRelevanceFieldEnum = {
  statement: 'statement',
  solution: 'solution',
  answer: 'answer',
  preview: 'preview',
  meta: 'meta'
};

exports.Prisma.FigureOrderByRelevanceFieldEnum = {
  url: 'url',
  alt: 'alt'
};

exports.Prisma.NoteOrderByRelevanceFieldEnum = {
  content: 'content',
  description: 'description'
};

exports.Prisma.TagOrderByRelevanceFieldEnum = {
  name: 'name'
};

exports.Prisma.TopicOrderByRelevanceFieldEnum = {
  slug: 'slug',
  name: 'name',
  imageSrc: 'imageSrc',
  theory: 'theory',
  meta: 'meta'
};

exports.Prisma.BranchOrderByRelevanceFieldEnum = {
  slug: 'slug',
  name: 'name',
  imageSrc: 'imageSrc',
  theory: 'theory',
  meta: 'meta',
  genitive: 'genitive'
};

exports.Prisma.ContentBlockOrderByRelevanceFieldEnum = {
  name: 'name',
  content: 'content'
};

exports.Prisma.PageOrderByRelevanceFieldEnum = {
  slug: 'slug',
  title: 'title',
  content: 'content'
};

exports.Prisma.MetadataOrderByRelevanceFieldEnum = {
  pageSlug: 'pageSlug',
  title: 'title',
  description: 'description'
};

exports.Prisma.EventLogOrderByRelevanceFieldEnum = {
  eventType: 'eventType',
  description: 'description',
  userId: 'userId'
};

exports.Prisma.PaymentOrderByRelevanceFieldEnum = {
  yookassaPaymentId: 'yookassaPaymentId',
  yookassaRefundId: 'yookassaRefundId',
  userId: 'userId'
};
exports.SubscriptionStatus = exports.$Enums.SubscriptionStatus = {
  PENDING: 'PENDING',
  SUBSCRIBED: 'SUBSCRIBED',
  UNSUBSCRIBED: 'UNSUBSCRIBED'
};

exports.AccessLevel = exports.$Enums.AccessLevel = {
  NONE: 'NONE',
  RESTRICTED: 'RESTRICTED',
  FULL: 'FULL'
};

exports.Difficulty = exports.$Enums.Difficulty = {
  EASY: 'EASY',
  MEDIUM: 'MEDIUM',
  HARD: 'HARD'
};

exports.Status = exports.$Enums.Status = {
  PENDING: 'PENDING',
  REVIEW: 'REVIEW',
  REJECTED: 'REJECTED',
  PUBLISHED: 'PUBLISHED'
};

exports.Placement = exports.$Enums.Placement = {
  LATERALLY: 'LATERALLY',
  BELOW: 'BELOW'
};

exports.FillInStatus = exports.$Enums.FillInStatus = {
  EMPTY: 'EMPTY',
  FILLING: 'FILLING',
  COMPLETED: 'COMPLETED'
};

exports.Currency = exports.$Enums.Currency = {
  RUB: 'RUB',
  EUR: 'EUR',
  USD: 'USD'
};

exports.PaymentStatus = exports.$Enums.PaymentStatus = {
  PENDING: 'PENDING',
  SUCCEEDED: 'SUCCEEDED',
  CANCELED: 'CANCELED'
};

exports.PaymentAction = exports.$Enums.PaymentAction = {
  WAITING: 'WAITING',
  CREDITED: 'CREDITED',
  REFUNDED: 'REFUNDED',
  CANCELED: 'CANCELED'
};

exports.Prisma.ModelName = {
  Admin: 'Admin',
  AdminSession: 'AdminSession',
  SubscriptionPlan: 'SubscriptionPlan',
  User: 'User',
  UserAccess: 'UserAccess',
  Session: 'Session',
  Problem: 'Problem',
  Figure: 'Figure',
  Note: 'Note',
  Tag: 'Tag',
  Topic: 'Topic',
  Branch: 'Branch',
  ContentBlock: 'ContentBlock',
  Page: 'Page',
  Metadata: 'Metadata',
  EventLog: 'EventLog',
  Payment: 'Payment'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
